import React from 'react'

const CTA = () => {
  return (
    <div className='cta'>
        <a href="https://drive.google.com/file/d/153J4-dBswqJqzp1o7K1vnJz8FE5JOQBR/view?usp=sharing" download="true" className='btn'> Download CV</a>
        <a href="#contact" className='btn btn-primary'>Let's Talk</a>

    </div>
  )
}

export default CTA